import { FC } from 'react'
import { Link } from 'react-router-dom'
import { useIntl } from 'react-intl'
import { FeatureGuard } from '../../../../Utils/featureComponents'
import { useAuthStore } from '../../../../store/authStore'
import { useLogout } from '../../../../hooks/queries/useAuth'
import { UserRound } from 'lucide-react'
// import { UserModel } from '../../../../app/modules/auth/models/UserModel'

const HeaderUserMenu: FC = () => {
  const intl = useIntl()
  const currentUser = useAuthStore((state) => state.user)
  const { mutate: logout } = useLogout()
  return (
    <>
      <div
        className='py-4 menu-rounded w-275px menu menu-sub menu-sub-dropdown menu-column menu-gray-600 menu-state-bg menu-state-primary fw-bold fs-6 costume_rtl_menu'
        data-kt-menu='true'
      >
        <div className='px-3 menu-item'>
          <div className='d-flex align-items-center px-3 menu-content'>
            <div className='d-flex justify-content-center align-items-center symbol symbol-50px me-5'>
              <UserRound size={40} className='text-muted' />
            </div>

            <div className='d-flex flex-column'>

              <a href='#' className='text-hover-primary text-muted fw-bold fs-7'>
                {currentUser ? currentUser?.email : ''}
              </a>
            </div>
          </div>
        </div>

        <FeatureGuard featureId='subscription_menu'>
          <div className='my-2 separator'></div>

          <div
            className='px-5 menu-item menu-accordion'
            data-kt-menu-trigger='click'
          >
            <a href='#' className='px-5 menu-link'>
              <span className='menu-title'>{intl.formatMessage({ id: 'My Subscription' })} </span>
              <span className='menu-arrow'></span>
            </a>

            <div className='menu-sub menu-sub-accordion'>
              <FeatureGuard featureId='price_plan'>
                <div className='px-3 menu-item'>
                  <Link to='price-plan' className='px-5 menu-link'>
                    {intl.formatMessage({ id: 'Plans' })}
                  </Link>
                </div>
              </FeatureGuard>
              <FeatureGuard featureId='services'>
                <div className='px-3 menu-item'>
                  <Link to='services' className='px-5 menu-link'>
                    {intl.formatMessage({ id: 'Services' })}
                  </Link>
                </div>
              </FeatureGuard>
              <FeatureGuard featureId='invoices'>
                <div className='px-3 menu-item'>
                  <Link to='Invoices' className='px-5 menu-link'>
                    {intl.formatMessage({ id: 'Invoices' })}
                  </Link>
                </div>
              </FeatureGuard>
              <FeatureGuard featureId='payment_history'>
                <div className='px-3 menu-item'>
                  <Link to='payment-history' className='px-5 menu-link'>
                    {intl.formatMessage({ id: 'Payment history' })}
                  </Link>
                </div>
              </FeatureGuard>
            </div>
          </div>

          <div className='my-2 separator'></div>
        </FeatureGuard>

        <FeatureGuard featureId='tickets'>
          <div className='my-1 px-5 menu-item'>
            <Link to='/ticket' className='px-5 menu-link'>
              {intl.formatMessage({ id: 'Ticket' })}
            </Link>
          </div>
        </FeatureGuard>

        <div className='my-1 px-5 menu-item'>
          <Link to='/crafted/account/settings' className='px-5 menu-link'>
            {intl.formatMessage({ id: 'Account Settings' })}
          </Link>
        </div>
        <div className='my-1 px-5 menu-item'>
          <Link to='/crafted/account/security' className='px-5 menu-link'>
            {intl.formatMessage({ id: 'Security' })}
          </Link>
        </div>

        <FeatureGuard featureId='organization'>

          <div className='my-1 px-5 menu-item'>
            <Link to='/organization' className='px-5 menu-link'>
              {intl.formatMessage({ id: 'Organizations Setting' })}
            </Link>
          </div>

        </FeatureGuard>
        <div className='my-1 px-5 menu-item'>
          <Link to='/select-organization' className='px-5 menu-link'>
            {intl.formatMessage({ id: 'Organizations Switch' })}
          </Link>
        </div>

        <div className='px-5 menu-item'>
          <a
            onClick={() => {
              const fcmToken = localStorage.getItem('fcmToken')
              logout()
            }}
            className='px-5 menu-link'
          >
            {intl.formatMessage({ id: 'Sign Out' })}
          </a>
        </div>
      </div>
    </>
  )
}

export { HeaderUserMenu }

{
  /* <div className='px-5 menu-item'>
        <Link to={'/crafted/pages/profile'} className='px-5 menu-link'>
          My Profile
        </Link>
      </div> 
      
      <div className='px-5 menu-item'>
        <a href='#' className='px-5 menu-link'>
          <span className='menu-text'>My Projects</span>
          <span className='menu-badge'>
            <span className='badge badge-light-danger badge-circle fw-bolder fs-7'>3</span>
          </span>
        </a>
      </div> */
}
{
  /* <div className='px-5 menu-item'>
        <a href='#' className='px-5 menu-link'>
          My Statements
        </a>
      </div> */
}
